import { render, staticRenderFns } from "./PriceSimulator.vue?vue&type=template&id=3832b025&scoped=true"
import script from "./PriceSimulator.vue?vue&type=script&lang=js"
export * from "./PriceSimulator.vue?vue&type=script&lang=js"
import style0 from "./PriceSimulator.vue?vue&type=style&index=0&id=3832b025&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3832b025",
  null
  
)

export default component.exports